import React from 'react';
import EllipsisText from '../../common/components/EllipsisText';
import { PUNCTUATION_MARKS_CONSTANTS } from '../../common/constants/constants';
import { FORM_WIDGET_COMPONENTS } from '../../common/form/formConstants';
import FormWidget from '../../common/form/FormWidget';
import { V } from '../../common/Layout';
import { useStyling } from '../../common/Theme';
import { Attribute } from '../attributes';

type DefaultAttributePreviewProps = {
    attribute: Attribute;
};

export default (props: DefaultAttributePreviewProps) => {
    const { attribute } = props;
    const { theme } = useStyling();
    return (
        attribute && (
            <V>
                <EllipsisText text={attribute.label} sx={{ fontSize: 12, color: theme.palette.text.secondary }} />
                <FormWidget
                    name="content"
                    value={attribute.value || PUNCTUATION_MARKS_CONSTANTS.dash}
                    component={FORM_WIDGET_COMPONENTS.richText}
                    onChange={() => {}} // We don't want it to be editable. But we want to use onChange in FormWidget instead of FormContext
                    sx={{ border: 'none', padding: 0 }}
                    readOnly
                    disableTranslation
                />
            </V>
        )
    );
};
